const styles = {
  root: {},
  button: {
    backgroundColor: 'background.white',
    border: 1,
    borderColor: 'background.border',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'text.grey300',
    '&.selected': {
      backgroundColor: 'highlight.main',
      color: 'text.white',
    },
  },
  draggableContainer: {
    display: 'flex',
    overflowX: 'scroll',
    overflowY: 'none',
    flexWrap: 'nowrap',
    gap: 2,
    paddingX: 1,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&::-webkit-scrollbar:horizontal': {
      display: 'none',
    },
    '&::-webkit-scrollbar:vertical': {
      display: 'none',
    },
    '&::-webkit-scrollbar-track': {
      display: 'none',
    },
  },

  states: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    mt: 2,
  },
}
export default styles
